export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const defaultFirestoreHost = '127.0.0.1';
const defaultFirestorePort = '8080';

export const EMULATOR_CONFIG = {
  AUTH: process.env.REACT_APP_AUTH_EMULATOR_URL,
  FIRESTORE: {
    host: process.env.REACT_APP_FIRESTORE_EMULATOR_HOST || defaultFirestoreHost,
    port: process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || defaultFirestorePort,
  },
  STORAGE: {
    host: process.env.REACT_APP_STORAGE_EMULATOR_HOST,
    port: process.env.REACT_APP_STORAGE_EMULATOR_PORT,
  },
};

export const USE_EMULATOR = process.env.REACT_APP_USE_EMULATOR === 'true';
